import React from 'react';
import { useSiteContent } from '../../context/SiteContentContext';
import './HeroIntro.css';

const parseParagraphs = (text) =>
  String(text || '')
    .split(/\r?\n+/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

const HeroIntro = () => {
  const { siteContent } = useSiteContent();
  const title = String(siteContent?.hero_intro_title || '').trim();
  const paragraphs = parseParagraphs(siteContent?.hero_intro_text);

  if (!title && paragraphs.length === 0) {
    return null;
  }

  return (
    <section className="hero-intro">
      <div className="hero-intro-container">
        {title && <h2 className="hero-intro-title">{title}</h2>}
        {paragraphs.map((text, index) => (
          <p
            key={index}
            className={`hero-intro-text ${index === paragraphs.length - 1 ? 'hero-intro-last' : ''}`}
          >
            {text}
          </p>
        ))}
      </div>
    </section>
  );
};

export default HeroIntro;
